var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"done-box"},[_c('div',{staticClass:"done-tips"},[_vm._v(" 已提交的信息可通过【基础信息-个人信息表】查看 ")])])}]

export { render, staticRenderFns }